module.exports = __webpack_public_path__ + "img/cc-mbs-reta.6aa76727.png";